import { render, staticRenderFns } from "./LoadingSVG.vue?vue&type=template&id=b40a1f9e&scoped=true"
import script from "./LoadingSVG.vue?vue&type=script&lang=ts"
export * from "./LoadingSVG.vue?vue&type=script&lang=ts"
import style0 from "./LoadingSVG.vue?vue&type=style&index=0&id=b40a1f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40a1f9e",
  null
  
)

export default component.exports